import { Dialog, DialogTitle, DialogContent, TextField, FormHelperText, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { CancelIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { buttonLabels } from "../shared/constants";
import { ChannelContactModel, mapToUser } from "../../models/conversations";
import { UtilityService } from "../../services/UtilityService";
import DateAndTimePicker from "../shared/datetimepicker/date-timepicker.component";
import { ChannelUserModel, UserModel, mapToChannelUser } from "../../models/users.model";
import { ChannelContactServices } from "../../services/channels/ChannelContactService";
import { emailValidator, nameValidator } from "../shared/form-validation";

interface Props {
    show: boolean;
    onClose: (isConfirmed?: boolean) => void;
    Contact?: ChannelContactModel;
    rowId?: string | null;
    clearSelection?: () => void;
}

const ChannelEditContactComponent: React.FC<Props> = (props: Props) => {

    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    const [contact, setContact] = useState<ChannelContactModel>(props.Contact)
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [errors, setErrors] = useState<{
        FirstName: string,
        Email: string,
    }>({
        FirstName: "",
        Email: "",
    })

    const handleChange = (name: any, value: any, id?: string) => {
        let Contact = contact
        Contact = { ...contact, CustomFields: contact.CustomFields.map(x => x.ID !== id ? x : { ...x, Value: value }) }
        setContact(Contact)
    }

    const handleName = (value: any) => {
        let Contact = contact
        Contact = { ...contact, FirstName: value }
        setContact(Contact)
        setErrors({ ...errors, FirstName: nameValidator(value) })
    }

    const handleEmail = (value: any) => {
        let Contact = contact
        Contact = { ...contact, Email: value }
        setContact(Contact)
        if (value) {
            setErrors({ ...errors, Email: emailValidator(value) })
        }
        else {
            setErrors({ ...errors, Email: "" })
        }
    }

    const handleEndTimeDate = (dateTime: any, id: string) => {
        let Contact = contact
        Contact = { ...contact, CustomFields: contact.CustomFields.map(x => x.ID !== id ? x : { ...x, Value: dateTime }) }
        setContact(Contact)
    }

    const UpdateCustomFieldsValue = () => {
        setIsLoading(true)
        let payload = {
            "id": contact.ID,
            "tenant_id": contact.OrganizationId,
            "account_id": contact.ChannelId,
            "data": {
                "phone": {
                    "mp_id": contact.PhoneId
                },
                "facebook": {
                    "mp_id": contact.FacebookId
                },
                "instagram": {
                    "mp_id": contact.InstagramId
                },
                "whatsapp": {
                    "mp_id": contact.WhatsappId
                },
                "livechat": {
                    "mp_id": contact.LiveChatId
                },
                "google": {
                    "mp_id": contact.GoogleId
                }
            },
            "primary": contact.PrimaryChannel,
            "primary_data": {
                "first_name": contact.FirstName,
                "last_name": contact.LastName,
                "email": contact.Email,
                "profile_pic": contact.ProfilePicLink,
                "user_gender": contact.Gender,
                "user_location": contact.Location
            },
            "custom_fields": contact.CustomFields.map(x => { return { "id": x.ID, "name": x.Name, "type": x.Type, "value": x.Value } }),
            "updated_by": user.ID,
            "created_at": contact.CreatedDateTime,
            "updated_at": new Date().toISOString(),
            "is_archived": contact.IsArchived,
            "unread_count": contact.UnreadCount,
            "re_opened_at": new Date().toISOString(),
            "message_activity": contact.LastMessageActivity
        }
        ChannelContactServices.UpdateContactCustomFieldValue(user.OrganizationID, contact.ID, payload).then(res => {
            props.onClose(true)
            setIsLoading(false)
        }
        ).catch(err => {

        })
    }

    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: "w-66 br-2 dialogue-shadow" }}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            open={props.show}
            onClose={() => props.onClose()}
            disableEscapeKeyDown
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header">
                <div className='d-flex'>
                    <span className={"h2-regular color-text-field-font"}>{"Edit Contact"}</span>
                    <Tooltip title='Close' placement='bottom'>
                        <CancelIcon className={"c-pointer ml-auto pr-1"} onClick={() => props.onClose()} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent className=" o-hidden pb-2">
                <div className="h-p-85 o-y-scroll pt-1">
                    <TextField
                        name="Name"
                        placeholder="Name"
                        label="Name"
                        variant="outlined"
                        size="small"
                        required
                        fullWidth
                        value={contact.FirstName}
                        onChange={(e) => handleName(e.target.value)}
                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                        autoComplete='no'
                    />
                    <FormHelperText className={'h6-regular color-primary-danger t-align-right'}>
                        {errors.FirstName}
                    </FormHelperText>
                    <TextField
                        fullWidth
                        label="Email"
                        name="Email"
                        placeholder="Email"
                        size="small"
                        variant="outlined"
                        value={contact.Email || ""}
                        onChange={(e) =>
                            handleEmail(e.target.value)
                        }
                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                        className="mt-2"
                        autoComplete='no'
                    />
                    <FormHelperText className={'h6-regular color-primary-danger t-align-right'}>
                        {errors.Email}
                    </FormHelperText>
                    {
                        contact.CustomFields.map(x => x.Type === "Text" ?
                            <TextField
                                autoFocus
                                className="mt-2"
                                placeholder="Characters"
                                label={x.Name}
                                variant="outlined"
                                size="small"
                                required
                                fullWidth
                                value={x.Value}
                                onChange={(e) => handleChange(e.target.name, e.target.value, x.ID)}
                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                autoComplete='no'
                            />
                            : x.Type === "Number" ?
                                <TextField
                                    autoFocus
                                    type="number"
                                    placeholder="Number"
                                    label={x.Name}
                                    name="Number"
                                    className="mb-2"
                                    variant='outlined'
                                    required
                                    fullWidth
                                    size='small'
                                    InputProps={{ classes: { input: 'h2 color-text-field-font' } }}
                                    value={x.Value}
                                    onChange={(e) => handleChange(e.target.name, e.target.value, x.ID)}
                                    autoComplete='no'
                                />
                                : x.Type === "Date (DD/MM/YY)" &&
                                <div className="mb-2">
                                    <DateAndTimePicker handleChange={handleEndTimeDate} DateTime={x.Value ? Number(x.Value) : -1} TextLabel={x.Name} ID={x.ID} />
                                </div>
                        )
                    }
                </div>
                <div className="d-flex float-right mt-1 pr-1">
                    <ButtonComponent OnClick={() => UpdateCustomFieldsValue()} ButtonLabel={buttonLabels.SAVE} Loading={IsLoading} ClassName={"px-4 mr-2 "} Variant={!!(errors.FirstName || errors.Email) ? "disabled-btn-small" : "primary-btn-small"} />
                    <ButtonComponent OnClick={() => props.onClose()} ButtonLabel={buttonLabels.CANCEL} ClassName={""} Variant={"secondary-btn-small"} />
                </div>
            </DialogContent>

        </Dialog>
    )
}

export default ChannelEditContactComponent;